import React from 'react';

export default function YesOrNo(props) {
  const { getValue, setValue, label} = props;
  const strings = window.themeStrings || {};
  return (
    <fieldset className="form-field">
      <legend className="form-legend">{label}</legend>
      <div className="option-values option-values-one-line">
        <div className="option-value">
          <input
            type="radio"
            className="option-value-input"
            id={`yesOrNo-0`}
            name="yesOrNo"
            value={true}
            checked={getValue === true}
            onChange={() => setValue(true)} />
          <label htmlFor={`yesOrNo-0`} className="option-value-name">{strings.fit_finder_common_yes}</label>
        </div>
        <div className="option-value">
          <input
            type="radio"
            className="option-value-input"
            id={`yesOrNo-1`}
            name="yesOrNo"
            value={false}
            checked={getValue === false}
            onChange={() => setValue(false)} />
          <label htmlFor={`yesOrNo-1`} className="option-value-name">{strings.fit_finder_common_no}</label>
        </div>
      </div>
    </fieldset>
  );
}